module.exports = __webpack_public_path__ + "img/bangladesh.6226d226.png";